import React from 'react'
import { useTranslationMap } from './use-translation-map'

/**
 * @description This HOC transforms a translation map to the respective translated strings.
 * For parameterized translations it returns a function that needs to be called with a
 * parameter object and will return the translated and subtituted string. The translations are passed
 * into the component as props and can be overwritten.
 *
 * @param {Object.<string, {stringCode: string, fallback: string, parameters?: string[]}>} translationMap -
 * a record listing all required translations and their defintion object.
 *
 * @returns {(component: React.Component<P>) => React.FC<P>} A component with all translations provided by the translation map
 */
export function withTranslationMap(translationMap) {
    return Component => {
        const TranslatedComponent = props => {
            const translations = useTranslationMap(translationMap, props)

            return <Component {...props} {...translations} />
        }
        TranslatedComponent.displayName = `Translated${Component.displayName || 'Component'}`
        return TranslatedComponent
    }
}
